import { useEffect } from "react";
import { goal, stage } from "@flights/et-universal";
import useCaParamsCleanup from "../../hooks/useCaParamsCleanup.js";
import useAlternativeFaresParams from "../../hooks/useAlternativeFaresParams.js";
import { isOfMetaOrigin } from "../../utils/marketing-url-params.js";
import useClientCachedURL from "../../hooks/useClientCachedURL.js";
import useTrackPageLoad from "../../hooks/useTrackPageLoad.js";
import useProfiler from "../../hooks/useProfiler.js";
import tph_flights_price_discrepancy_aa from "../../utils/experiments/funnel/tph_flights_price_discrepancy_aa.js";
import flights_web_apex_ancillaries_aa from "../../utils/experiments/apex/flights_web_apex_ancillaries_aa.js";
import { trackMetaChannelStagesV2 } from "../../utils/experiments/track-meta-landings-v2.js";
import { trackLoggedInUsersFD, trackLoggedInUsersFDmDot, trackLoggedInUsersFDFromTPH } from "../../utils/experiments/funnel/tph_save_flights_aa.js";
import useTrackFlightsWebUseOfferPos from "../../hooks/useTrackFlightsWebUseOfferPosExp.js";
import { getMarketingTrackingVariable } from "@flights/web-api-utils-universal";
import useFlightOfferInSearchResults from "../../hooks/useFlightOfferInSearchResults.js";
export function useFlightDetailsMobileEffects(params, queryParams, urlParams) {
    const isMetaUser = isOfMetaOrigin();
    const { isLoggedInAuthLow } = useProfiler();
    const cleanupCaParams = useCaParamsCleanup();
    const { getTotalPrice } = useFlightOfferInSearchResults();
    const { cacheLastSuccessfulSearchUrl } = useClientCachedURL();
    const flightsWebUseOfferPos = useTrackFlightsWebUseOfferPos();
    const trackContextEventV2 = useTrackPageLoad("flight_details");
    const { setAlternativeFaresParams, setAlternativeFaresSearchedAtParam } = useAlternativeFaresParams();
    useEffect(() => {
        trackContextEventV2();
        goal("flights_flight_details_page_view");
        stage("flights_funnel_new_fd_page_mobile", 1);
        cacheLastSuccessfulSearchUrl(params?.airports);
        trackMetaChannelStagesV2("mdot");
        flights_web_apex_ancillaries_aa.stages.flight_details();
        if (isLoggedInAuthLow()) {
            trackLoggedInUsersFD();
            trackLoggedInUsersFDmDot();
            const adplat = queryParams.get("adplat");
            if (adplat && adplat.includes("wishlist-flight")) {
                trackLoggedInUsersFDFromTPH();
                tph_flights_price_discrepancy_aa.stages.all_logged_in_from_wishlist();
                tph_flights_price_discrepancy_aa.stages.web_logged_in_from_wishlist();
            }
        }
    }, []);
    useEffect(() => {
        setAlternativeFaresSearchedAtParam(isMetaUser);
    }, [setAlternativeFaresSearchedAtParam, isMetaUser]);
    useEffect(() => {
        const salesCountry = getMarketingTrackingVariable("salesCountry");
        const { units, nanos, currencyCode } = getTotalPrice(params?.id, urlParams.get("baseOfferToken") || "") || {};
        if (units)
            setAlternativeFaresParams("priceInSearch", `${units}-${nanos}-${currencyCode}`);
        if (!units)
            setAlternativeFaresParams("priceInSearch", "");
        if (flightsWebUseOfferPos.isVariant && salesCountry) {
            setAlternativeFaresParams("salesCountry", salesCountry);
        }
    }, [flightsWebUseOfferPos, setAlternativeFaresParams, getTotalPrice, params, urlParams]);
    useEffect(() => () => {
        cleanupCaParams();
    }, [cleanupCaParams]);
}
